import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-footer" }

import { postLogin } from "@/api/functions/home";
import {
  LoginModel,
  initLoginModel,
} from "@/api/apitypes/request/AccountRequest";
import { reactive, inject } from "vue";
import { ElMessage } from "element-plus";
// import { reloadKey } from "@/functions/keys/index";

interface backgroundStyleIf {
  backgroundImage: string;
  backgroundSize: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  props: {
  loginVisible: {
    type: Object as any,
    visible: false,
  },
},
  setup(__props) {

const form = reactive({
  username: "",
  password: "",
});

// const reload = inject(reloadKey);

const onLogin = async () => {
  const loginCat: LoginModel = initLoginModel(form.username, form.password);

  await postLogin(loginCat).then((res) => {
    if ((res.data.code === "0")) {
      localStorage.setItem("token", res.data.data as string);
      props.loginVisible.visible = false;
      //   if (reload === undefined) {
      //     throw new Error('Failed to inject "updateScore"');
      //   }
      location.reload();
      //   reload();
    } else {
      ElMessage({
        message: res.data.msg,
        showClose: true,
        type: "error",
      });
    }
  });
};

const props = __props;

const backgroundStyle = reactive<backgroundStyleIf>({
  backgroundImage: "url(" + require("@/assets/loginCat.gif") + ")",
  backgroundSize: "cover",
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: __props.loginVisible.visible,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((__props.loginVisible.visible) = $event)),
    title: "登录",
    width: "500",
    "align-center": "",
    center: "",
    style: _normalizeStyle(backgroundStyle)
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (__props.loginVisible.visible = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: onLogin
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 登录 ")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, { model: form }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { prop: "username" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: form.username,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.username) = $event)),
                clearable: "",
                placeholder: "请输入账号"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { prop: "password" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: form.password,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.password) = $event)),
                clearable: "",
                placeholder: "请输入密码",
                "show-password": ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["modelValue", "style"]))
}
}

})